import React from 'react';
import type { LinkedWiki } from '../../types/wiki';

// 「哪几页 wiki 讲的是这条任务」。与 LinkedWorklogs 是对称的一对（都在
// Todo/ 下，同一套 todo-* token），数据来自 TaskPresenter#linked_wikis_json。
//
// 没有关联时整块不渲染，与本目录 LinkedWorklogs 的留空态刻意不同：
// wiki 关联是「顺手补充的参考资料」，不是任务本身要推进的东西，给每条任务
// 都留一句「暂无 wiki」是噪音——真正开始有 wiki 知识沉淀的任务本来就是少数。

type LinkedWikisProps = {
  wikis: LinkedWiki[];
};

const LinkedWikis: React.FC<LinkedWikisProps> = ({ wikis }) => {
  if (wikis.length === 0) return null;

  return (
    <div className="mb-[9px]">
      <div className="mb-[7px] flex items-baseline gap-[7px] px-0.5">
        <span className="text-[12.5px] font-semibold">关联的 wiki</span>
        <span className="rounded-full border border-todo-line bg-todo-card px-1.5 py-px font-mono text-[11px] text-todo-muted">
          {wikis.length}
        </span>
      </div>

      {wikis.map((wiki) => (
        <a
          key={wiki.url_key}
          href={`/wiki/${wiki.url_key}`}
          className="mb-[7px] flex items-center gap-1.5 rounded-lg border border-todo-line bg-todo-card px-[10px] py-2 no-underline last:mb-0 hover:border-todo-line2"
        >
          <span className="min-w-0 flex-1 truncate text-[12.5px] leading-snug text-todo-ink">
            {wiki.title}
          </span>
          {wiki.linked_by === 'agent' && (
            <span className="text-[11px] text-todo-accent" title="AI 关联">
              ✦
            </span>
          )}
        </a>
      ))}
    </div>
  );
};

export default LinkedWikis;
